<template>
  <div style="padding-bottom: 20px; background: #f6f8fa">
    <!-- 首页弹框 -->
    <div class="flowTk" v-if="tkShow">
        <div class="tkBox">
          <img @click="tkShow = false" class="close" src="../assets/images/close.png" alt="">
          <img @click="toUrl" class="tkImg" :src="adPicture.picUrl" alt=""></img>
        </div>
    </div>



    <div class="head">首页</div>
    <div class="searCh" @click="goSear">
      <div style="position: relative; height: 42px; width: 100%">
        <div type="text" class="searI">
          <div class="serFle">
            <div>
              <img class="sera" src="../assets/images/sear@2x.png" alt="" />
            </div>
            <div style="margin-left: 5px">搜索您想要的关键词</div>
          </div>
        </div>
      </div>
    </div>

    <div class="banner">
      <div class="bns">
        <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
          <van-swipe-item v-for="item in pictureList" :key="item.id" @click="swipeDetail(item)">
            <img class="swImg" :src="item.picUrl" alt="安徽继续教育网" />
          </van-swipe-item>
        </van-swipe>

        <div class="xkList">
          <div class="bsa" @click="goYm(1)">
            <div style="display: flex; justify-content: center">
              <img class="xkImg" src="../assets/images/bmxk@2x.png" alt="" />
            </div>
            <div class="xkText">报名选课</div>
          </div>
          <div class="bsa" @click="goYm(2)">
            <div style="display: flex; justify-content: center">
              <img class="xkImg" src="../assets/images/xxzx@2x.png" alt="" />
            </div>
            <div class="xkText">学习中心</div>
          </div>
          <div class="bsa" @click="goYm(3)">
            <div style="display: flex; justify-content: center">
              <img class="xkImg" src="../assets/images/zscy@2x.png" alt="" />
            </div>
            <div class="xkText">证书查验</div>
          </div>
          <div class="bsa" @click="goYm(4)">
            <div style="display: flex; justify-content: center">
              <img class="xkImg" src="../assets/images/mnlx@2x.png" alt="" />
            </div>
            <div class="xkText">模拟练习</div>
          </div>
        </div>
               <!-- 邀请新用户 -->
        <div class="newuser" @click="handleInvited">
         邀请新用户报名 终身领积分
        </div>
        <!-- 快速选择 -->
        <div class="rapid">
          <div class="rapid_ti">
            <div class="rapid_img"><img src="../assets/images/left@2x.png" alt="" /></div>
            <div class="title_1">快速选择</div>
            <div class="title_2">找到属于自己的学习入口</div>
          </div>
          <div class="rapid_box">
            <div class="box_left" @click="more('0702')">
              <div class="title_3" style="font-family: Alibaba PuHuiTi, Alibaba PuHuiTi; font-weight: 800; font-size: 16px; color: #0c67d1">
                继续教育
              </div>
              <div class="title_4">完成继续教育学时是职称参评必备，属终身学习活动。</div>
            </div>
            <!-- <div class="box_right"> -->
            <div class="box_1" @click="more('0703')">
              <div class="title_3" style="font-family: Alibaba PuHuiTi, Alibaba PuHuiTi; font-weight: 800; font-size: 16px; color: #00bc77">
                转岗培训
              </div>
              <div class="title_4">跨系列跨专业晋升职称，须完成转岗继续教育任务。</div>
            </div>
            <div class="box_2" @click="more('0705')">
              <div class="title_3" style="font-family: Alibaba PuHuiTi, Alibaba PuHuiTi; font-weight: 800; font-size: 16px; color: #e66145">
                职业培训
              </div>
              <div class="title_4">精准定向训战融合，强化岗位能力促就业发展。</div>
            </div>
            <!-- </div> -->
          </div>
        </div>
        <!-- 公告资讯 -->
        <div class="group_1" @click="hadleMore">
          <div class="group_img"><img src="../assets/new/gonggao.png" alt="" /></div>
          <div class="text_1">{{ infoMessage.title }}</div>
          <div style="display: flex; align-items: center" @click="hadleMore">
            <div class="text_2" style="height: 30px; display: flex; align-items: center">更多</div>
            <div class="group_icon" style="height: 30px; display: flex; align-items: center">
              <img src="../assets/images/more@2x.png" alt="" />
            </div>
          </div>
        </div>
 
        <!-- start专技教育 -->
        <div class="zjjy">
          <div class="zjHead">
            <div class="zjh1">
              <div><img src="../assets/images/left@2x.png" alt="" /></div>
              <div class="z1txt">专技教育</div>
            </div>
            <div class="zjh2" @click="more('0702')">
              <div class="zh2">查看更多</div>
              <div><img src="../assets/images/more@2x.png" alt="" /></div>
            </div>
          </div>
          <div class="scotl">
            <div
              :class="zjTabIndex == index ? 'zyBox activeBox' : 'zyBox'"
              v-for="(item, index) in zjjyCodeList"
              :key="item.id"
              @click="handleZj(item, index)"
            >
              {{ item.codeName }}
            </div>
          </div>
          <div style="padding-right: 15px">
            <div class="bto"></div>
          </div>
          <div class="courseBox" @click="handleDetail(item)" v-for="item in zjjyClassList" :key="item.id">
            <div class="couImg">
              <img v-if="item.classImage !== null" class="couImg" :src="item.classImage" alt="安徽继续教育网" />
              <img v-else class="couImg" src="../assets/images/noimg.png" alt="安徽继续教育网" />
            </div>
            <div class="courseText">
              <div class="c1">{{ item.className }}</div>
              <div class="c2">{{ item.classCredithour }}学时</div>
              <div style="display: flex; justify-content: space-between; width: 100%">
                <div class="c3" v-if="item.isClassApply == '01'">
                  <div style="font-size: 12px; color: #ff2d31; margin-top: 4px">¥</div>
                  <span style="color: #ff2d31; font-size: 17px">{{ item.creditPrice }}</span>
                  <div style="margin-top: 3px">/学时</div>
                </div>
                <div class="c3" v-else style="display: flex; align-items: center; justify-content: space-between">
                  <div style="display: flex">
                    <div style="font-size: 12px; color: #ff2d31; margin-top: 4px">¥</div>
                    <span style="color: #ff2d31; font-size: 17px">{{ item.classPrice.toFixed(1) }}</span>
                  </div>
                </div>
                <div class="paly" v-if="item.isClassApply == '02' && item.isBuy == '02'" @click.stop="watch2(item)">
                  <div>
                    <img src="../assets/images/playIcon@2x.png" alt="" />
                  </div>
                  <div class="sk">播放</div>
                </div>
                <div
                  style="margin-top: 8px"
                  class="btn"
                  v-if="item.isBuy == '01' && item.classEnrolStatus == '02' && item.isClassApply == '02'"
                >
<!--                  <span class="bofang" @click.stop="trySee(item)"> 试看</span>-->
                  <span class="pay" style='width: 80px;border-radius: 27px' @click.stop="handleorder(item)"> 购买</span>
                  <!-- <span class="pay1" @click.stop="handleorder(course)" v-if="course.resChapterVo==null||course.resChapterVo==''">购买</span> -->
                </div>
                <div class="btn"  v-if="item.classEnrolStatus == '02' && item.isClassApply == '01'">
<!--                  <span class="bofang" @click.stop="trySee(item)"> 试看</span>-->
                  <span class="pay" style='width: 80px;border-radius: 27px' @click.stop="handleorder(item)"> 购买</span>
                  <!-- <span class="pay1" @click.stop="handleorder(course)" v-if="course.resChapterVo==null||course.resChapterVo==''">购买</span> -->
                </div>
              </div>
            </div>
          </div>
          <div class="courseBox" style="text-align: center; font-size: 16px; margin-top: 20px" v-if="zjpxEmpty">
            <div style="text-align: center; font-size: 16px; margin-top: 20px; width: 100%">暂无数据 ~</div>
          </div>
        </div>
        <!-- end专技教育 -->
        <!-- start职业培训 -->
        <div class="zjjy" id="zjjy">
          <div class="zjHead">
            <div class="zjh1">
              <div><img src="../assets/images/left@2x.png" alt="" /></div>
              <div class="z1txt">职业培训</div>
            </div>
            <div class="zjh2" @click="more('0705')">
              <div class="zh2">查看更多</div>
              <div><img src="../assets/images/more@2x.png" alt="" /></div>
            </div>
          </div>
          <div class="scotl">
            <div
              :class="zyTabIndex == index ? 'zyBox activeBox' : 'zyBox'"
              v-for="(item, index) in zypxCodeList"
              :key="item.id"
              @click="handleZy(item, index)"
            >
              {{ item.codeName }}
            </div>
          </div>
          <div style="padding-right: 15px">
            <div class="bto"></div>
          </div>

          <div class="courseBox" @click="handleDetail(item)" v-for="item in zypxClassList" :key="item.id">
            <div class="couImg">
              <img v-if="item.classImage !== null" class="couImg" :src="item.classImage" alt="安徽继续教育网" />
              <img v-else class="couImg" src="../assets/images/noimg.png" alt="安徽继续教育网" />
            </div>
            <div class="courseText">
              <div class="c1">{{ item.className }}</div>
              <div class="c2">{{ item.classCredithour }}学时</div>
              <div class="c3" style="justify-content: space-between; align-items: center">
                <div style="display: flex" v-if="item.isClassApply == '01'">
                  <div style="font-size: 12px; color: #ff2d31; margin-top: 4px">¥</div>
                  <span style="color: #ff2d31; font-size: 17px">{{ item.creditPrice }}</span>
                  <div style="margin-top: 3px">/学时</div>
                </div>

                <div style="display: flex" v-else>
                  <div style="font-size: 12px; color: #ff2d31; margin-top: 4px">¥</div>
                  <span style="color: #ff2d31; font-size: 17px">{{ item.classPrice.toFixed(1) }}</span>
                  <div style="margin-top: 3px"></div>
                </div>
                <div class="paly" v-if="item.isClassApply == '02' && item.isBuy == '02'" @click.stop="watch(item)">
                  <div>
                    <img src="../assets/images/playIcon@2x.png" alt="" />
                  </div>
                  <div class="sk">播放</div>
                </div>
                <div class="btn" v-if="item.classEnrolStatus == '02' && item.isClassApply == '01'">
<!--                  <span class="bofang" @click.stop="trySee(item, 1)"> 试看</span>-->
                  <span class="pay" style='width: 80px;border-radius: 27px' @click.stop="handleorder(item)"> 购买</span>
                  <!-- <span class="pay1" @click.stop="handleorder(course)" v-if="course.resChapterVo==null||course.resChapterVo==''">购买</span> -->
                </div>
                <div class="btn" v-if="item.isBuy == '01' && item.classEnrolStatus == '02' && item.isClassApply == '02'">
<!--                  <span class="bofang" @click.stop="trySee(item, 1)"> 试看</span>-->
                  <span class="pay" style='width: 80px;border-radius: 27px' @click.stop="handleorder(item)"> 购买</span>
                  <!-- <span class="pay1" @click.stop="handleorder(course)" v-if="course.resChapterVo==null||course.resChapterVo==''">购买</span> -->
                </div>
              </div>
            </div>
          </div>
          <div class="courseBox" v-if="zypxEmpty">
            <div style="text-align: center; font-size: 16px; margin-top: 20px; width: 100%">暂无数据 ~</div>
          </div>
        </div>
        <!-- end职业培训 -->
        <!-- 课程资源库 -->
        <div class="kczyk" id="kczyk">
          <div class="kcHead">
            <div class="zjh1">
              <div><img src="../assets/images/left@2x.png" alt="" /></div>
              <div class="z1txt">课程资源库</div>
            </div>
            <div class="zjh2" @click="gotozyk">
              <div class="zh2">查看更多</div>
              <div><img src="../assets/images/more@2x.png" alt="" /></div>
            </div>
          </div>
          <div class="zykBox">
            <!-- 不是会员 -->
            <div v-if="this.isMember == '01'" style="display: flex; flex-wrap: wrap; justify-content: space-between">
              <div class="zykBox_1" v-for="t in zylList" :key="t.id" @click="noVip(t)">
                <div class="zykimg">
                  <img :src="t.cImage" alt="安徽继续教育网" v-if="t.cImage != null && t.cImage != ''" />
                  <img v-else class="couImg" src="../assets/images/noimg.png" alt="安徽继续教育网" />
                </div>
                <div class="zyktext">
                  <div class="zyktext_1">{{ t.cName }}</div>
                  <div class="zyktext_2">
                    <div class="zyk1">{{ t.cCredithour }}学时</div>
                    <div class="zyk2" v-if="t.isBuy == '02'" @click.stop="handleWatch(t)">
                      <img src="../assets/images/playIcon@2x.png" alt="" />
                      <div>播放</div>
                    </div>
                    <div class="zyk2" v-if="t.isBuy == '01'" @click.stop="trySee1(t)">
                      <img src="../assets/images/playIcon@2x.png" alt="" />
                      <div>试看</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 会员 -->
            <div v-if="this.isMember == '02'" style="display: flex; flex-wrap: wrap; justify-content: space-between">
              <div class="zykBox_1" v-for="t in zylList" :key="t.id" @click="handleWatch(t)">
                <div class="zykimg">
                  <img :src="t.cImage" alt="安徽继续教育网" v-if="t.cImage != null && t.cImage != ''" />
                  <img v-else class="couImg" src="../assets/images/noimg.png" alt="安徽继续教育网" />
                </div>
                <div class="zyktext">
                  <div class="zyktext_1">{{ t.cName }}</div>
                  <div class="zyktext_2">
                    <div class="zyk1">{{ t.cCredithour }}学时</div>
                    <div class="zyk2" @click.stop="handleWatch(t)">
                      <img src="../assets/images/playIcon@2x.png" alt="" />
                      <div>播放</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- start直播公开课 -->
        <!-- <div class="gkk">
          <div class="zjHead">
            <div class="zjh1">
              <div><img src="../assets/images/left@2x.png" alt="" /></div>
              <div class="z1txt">直播公开课</div>
            </div>
            <div class="zjh2">
              <div class="zh2">查看更多</div>
              <div><img src="../assets/images/more@2x.png" alt="" /></div>
            </div>
          </div>

          <div class="gkkBox" v-for="item in liveCourseList" :key="item.id">
            <div style="width: 100%; height: 160px">
              <img v-if="item.courseImg !== null" :src="item.courseImg" :alt="item.courseName" />

              <img v-else src="../assets/images/noimg.png" alt="安徽继续教育网" />
            </div>

            <div class="gkBtm">
              <div>
                <div class="g1">{{ item.courseName }}</div>
                <div class="g2">直播时间：{{ item.startTime }}</div>
              </div>
              <div>
                <div class="yyBox" @click="reservation">预约</div>
              </div>
            </div>
          </div>
        </div> -->
        <!-- end直播公开课 -->

        <!-- start关于冠成 -->

        <div class="gygc" style="margin-top: 20px">
          <div class="gyHead">
            <div class="gyTitle">
              <div>
                <img src="../assets/images/left2@2x.png" alt="" />
              </div>
              <div class="gy1">关于冠成</div>
              <div>
                <img src="../assets/images/right@2x.png" alt="" />
              </div>
            </div>
          </div>

          <div class="gybc">
            <img src="../assets/images/gybc@2x.png" alt="" />
            <div style="position: relative; z-index: 1">
              <div class="bc1">安徽冠成教育科技有限公司</div>
              <div class="bc2">专技教育、职业教育专业培训机构</div>
            </div>
          </div>

          <div class="gcTxt">
            <div class="gct1">
              <div style="font-size: 12px; color: #4076f6">
                <span style="font-size: 24px; font-weight: bold; color: #4076f6">13</span>年
              </div>

              <div style="margin-top: 6px">公司是国家级高新技术企业一员，其核心团队十三年来致力于继续教育领城。</div>
            </div>
            <div class="gct1">
              <div style="font-size: 12px; color: #4076f6">
                <span style="font-size: 24px; font-weight: bold; color: #4076f6">10</span>万+
              </div>

              <div style="margin-top: 6px">公司已累计究成10万+专业人才的继续教育培训工作为社会输入大量专业人才。</div>
            </div>
            <div class="gct1">
              <div style="font-size: 12px; color: #4076f6">
                <span style="font-size: 24px; font-weight: bold; color: #4076f6">省</span>级
              </div>

              <div style="margin-top: 6px">2014 年公司获批省级继教基地，2018 - 2024 年三度荣获“国家级高新技术企业”称号。</div>
            </div>
          </div>

          <div class="gcTxt">
            <div class="gct2">
              <div style="font-size: 12px; color: #4076f6">
                <span style="font-size: 24px; font-weight: bold; color: #4076f6">1000</span>万+
              </div>

              <div style="margin-top: 6px">一千余万次救学视频播放量为学员提供稳定、高效、便捷的在线视频播放教学服务。</div>
            </div>
            <div class="gct2">
              <div style="font-size: 12px; color: #4076f6">
                <span style="font-size: 24px; font-weight: bold; color: #4076f6">20</span>万+
              </div>

              <div style="margin-top: 6px">20余万种培训课程，课程资源覆盖各个领城的专业继续人才以及职业教育培训领城。</div>
            </div>
          </div>
        </div>

        <!-- end关于冠成 -->
      </div>
    </div>
   <van-popup v-model="balanceShow" round>
      <div class="balanBox">
        <div class="b1">账户余额抵扣支付</div>

        <van-checkbox-group v-model="balanRadio" icon-size="16px" class="bn2" @change="onCheckboxChange">
          <van-cell-group class="bn2">
            <van-cell clickable @click="toggleCheck('1')" v-if="balance>0">
              <div>
                <div class="b2">账户余额支付 ¥{{ Number(classPrice).toFixed(2) }}</div>
                <div class="b3">剩余{{ balanZkNum.toFixed(2) < 0 ? 0 : balanZkNum.toFixed(2) }}元</div>
              </div>
              <template #right-icon>
                <van-checkbox name="1" ref="checkboxes" />
              </template>
            </van-cell>
            <van-cell clickable @click="toggleCheck('2')" v-if="surplusIntegral>0">
              <div>
                  <div class="b2">账户积分抵扣 ¥{{Math.min((surplusIntegral / 30),classPrice).toFixed(2)}}</div>
                <div class="b3"  v-if="this.balanRadio[0]=='2'">剩余积分抵扣金额{{ balanZkNum1.toFixed(2) < 0 ? 0 : balanZkNum1.toFixed(2) }}元</div>
                <div class="b3" v-else>剩余积分抵扣金额{{ (surplusIntegral/30).toFixed(2) }}元</div>
              </div>
              <template #right-icon>
                <van-checkbox name="2" ref="checkboxes" />
              </template>
            </van-cell>
          </van-cell-group>
        </van-checkbox-group>

        <div class="btnBox">
          <div class="btn" style="background: #e4e4e4; color: #666666" @click="balanceShow = false">取消</div>
          <div class="btn" @click="toOrder">立即购买</div>
        </div>
      </div>
    </van-popup>
    <bottomNav :is-team="isTeam"></bottomNav>

    <div class="tk" v-if="bmShow">
      <div class="wtkBox">
        <img class="tkBac" src="../assets/images/tkbgc@2x.png" alt="" />

        <img class="closeBox" src="../assets/images/Vector@2x.png" alt="" @click="closeOpen" />

        <div class="wxTtile">温馨提示</div>

        <div class="wx2">{{ bmText }}前往<span style="color: #2d72f3">继续教育专区</span>选课购买。</div>

        <div class="wxBtn" @click="goBm">立即前往报名</div>
      </div>
    </div>
  </div>
</template>
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import bottomNav from './component/tabBar.vue';
import { toNewIndex, getClassList } from '../api/index';
import { toClassCenter, toTry } from '../api/chooseClass';
import { toGenerateOrder } from '../api/classDetail';
import { toCourseList } from '../api/vip';
import { Dialog } from 'vant';
import { toAllReadyBuy } from '@/api/myClass';
import { ylxAddOrder } from '@/api/myClass';

export default {
  // import引入的组件需要注入到对象中才能使用
  components: {
    bottomNav
  },
  data() {
    // 这里存放数据
    return {
      pictureList: [],
      savedScrollPosition: 0,
      zypxCodeList: [], //职业培训
      zypxClassList: [], //职业培训
      zjjyCodeList: [], //专技
      zjjyClassList: [], //职业培训
      liveCourseList: [], //直播公开课
      infoMessage: {}, //公告资讯
      zjTabIndex: 0,
      zyTabIndex: 0,
      zypxEmpty: false,
      zjpxEmpty: false,
      ajaxFalg: true,
      courselist: [],
      balanceShow: false,
      balanRadio: [],
      balanZkNum: 0, //折扣后剩下的余额
      surplusIntegral: 0, //积分
      balanZkNum1: 0, //折扣后剩下的积分

      payFalg: false,
      isTeam: true,
      balance: 0, //账户余额抵扣
      classPrice: '',
      isMember: '',
      zylList: [], //资源库
      bmShow: false,
      bmText: '',
      tkShow:false,
      adPicture:'',
    };
  },
  // 监听属性 类似于data概念
  computed: {},
  // 监控data中的数据变化
  watch: {},
  // 方法集合
  methods: {
      toUrl() {
      console.log(this.adPicture);
      if (this.adPicture.jumpway == '02') {
        //外部跳转
        location.href = this.adPicture.picDesc
        
      }else {
        return false
      }
    },
    toggleCheck(name) {
      if (this.balanRadio[0] === name) {
        this.balanRadio = [];
      } else {
        this.balanRadio = [name];
      }
      this.onCheckboxChange(this.balanRadio);
    },
    onCheckboxChange(value) {
      console.log('当前选中:', value);
    },
    toAllReadyBuy() {
      toAllReadyBuy().then(res => {
        if (localStorage.getItem('bmShow')) {
          this.bmShow = false;
          return false;
        }
        if (res.data.data.msg == '') {
          this.bmShow = false;
        } else {
          this.bmShow = true;
        }
        this.bmText = res.data.data.msg;
      });
    },
    goBm() {
      this.$router.push({
        path: '/chooseClass',
        query: {
          type: '0702'
        }
      });
    },
    //10s后关闭弹框，并且不在弹框
    closeOpen() {
      this.bmShow = false;
      localStorage.setItem('bmShow', false);
    },
  
    //跳转到详情页
    handleDetail(course) {
      if (course.isZYPX == '01') {
        //购买了直接跳学习页面
        if (course.isClassApply == '02' && course.isBuy == '02') {
          this.$router.push({
            path: '/myClass',
            query: {
              name: 'a'
            }
          });
        } else {
          this.$router.push({
            path: '/classDetail',
            query: { classId: course.id }
          });
        }
      } else {
        if (course.isClassApply == '02' && course.isBuy == '02') {
          this.$router.push({
            path: '/myClass',
            query: {
              name: 'b'
            }
          });
        } else {
          this.$router.push({
            path: '/zyDetail',
            query: { classNo: course.id }
          });
        }
      }
    },
    more(type) {
      this.$router.push({
        path: '/chooseClass',
        query: {
          type: type
        }
      });
    },
    reservation() {
      MessageBox.alert('功能暂未上线，敬请期待~', '温馨提示');
    },
    //获取职业班级
    getzypxClassList(codeNo) {
      let params = { codeNo: codeNo, token: localStorage.getItem('token') };
      toClassCenter(params).then(res => {
        this.zypxClassList = res.data.aClass.rows.slice(0, 3);

        if (this.zypxClassList.length == 0) {
          this.zypxEmpty = true;
        } else {
          this.zypxEmpty = false;
        }
      });
    },
    //获取专技班级
    getzjpxClassList(codeNo) {
      let params = { codeNo: codeNo, token: localStorage.getItem('token') };
      toClassCenter(params).then(res => {
        this.zjjyClassList = res.data.aClass.rows.slice(0, 3);

        this.balance = res.data.balance;
        this.surplusIntegral=res.data.surplusIntegral
        if (this.zjjyClassList.length == 0) {
          this.zjpxEmpty = true;
        } else {
          this.zjpxEmpty = false;
        }
      });
    },
    //专技点击
    handleZj(item, index) {
      this.zjTabIndex = index;
      this.getzjpxClassList(item.codeNo);
    },
    //职业点击
    handleZy(item, index) {
      this.zyTabIndex = index;
      this.getzypxClassList(item.codeNo);
    },
    //职业培训去学习页面播放
    watch(item) {
      this.$router.push({
        path: '/myClass',
        query: {
          name: 'b'
        }
      });
    },
    //专业课去学习也播放
    watch2(item) {
      this.$router.push({
        path: '/myClass',
        query: {
          name: 'a'
        }
      });
    },
    //轮播图详情
    swipeDetail(item) {
      if (item.jumpWay == '02') {
        if (item.picDesc.startsWith('http')) {
          window.location.href = item.picDesc; // 直接跳转到该地址
        } else {
          this.$router.push({
            path: '/noticeDetail',
            query: {
              id: item.id,
              index: 1
            }
          });
        }
      } else if (item.jumpWay == '01') {
        this.$router.push({
          path: '/noticeDetail',
          query: {
            id: item.id,
            index: 1
          }
        });
      }
    },
    //公告资讯
    hadleMore() {
      this.$router.push({ path: '/announcement' });
    },
    //获取数据
    getInfo() {
      this.zypxCodeList = [];
      toNewIndex().then(res => {
        this.pictureList = res.data.data.carousel;
        this.adPicture = res.data.data.picTanKua
         if (this.adPicture !== '' && this.adPicture !== null && this.adPicture !== undefined) {
          this.tkShow = true
        }else {
          this.tkShow = false
        }
        this.courselist = res.data.data.courselist;
        // this.courselist =  res.data.data.courselist
        //获取新闻资讯
        if(res.data.data.infoMessage[0]){
          this.infoMessage = res.data.data.infoMessage[0];
        }
        
        this.zypxCodeList = res.data.data.zypxList;
        this.getzypxClassList(this.zypxCodeList[0].codeNo);
        this.zjjyCodeList = res.data.data.jxjyList;
        this.getzjpxClassList(this.zjjyCodeList[0].codeNo);
        this.liveCourseList = res.data.data.liveCourseList;
        this.ajaxFalg = false;
      });
    },
    goSear() {
      this.$router.push('/select');
    },
    //试看
    trySee(course, index) {
      toTry({ classId: course.id }).then(res => {
        if (res.data.code == 200) {
          this.$router.push({
            path: '/tryPlaying',
            query: { id: res.data.data.cwId, name: res.data.data.chapterTitle, index: index, isZYPX: course.isZYPX }
          });
        } else if (res.data.code == 500) {
          this.$utils.showToast('该课程暂不支持试看');
        }
      });
    },
    //职业培训购买
    handleorder(course) {
      //02表示是职业培训课程
      if (course.isZYPX == '02') {
        const data = {
          classId: course.id,
          courseIds: '',
          derateType: '',
          equipment: '02'
        };
        toGenerateOrder(data).then(res => {
          if (res.data.data.result == 0) {
            //创建订单失败返回信息
            this.$utils.showToast(res.data.data.msg);
            return false;
          }
          if (res.data.data.result == 1) {
            //余额小于金额，抵扣后跳转到收银台继续支付或没勾选账户抵扣跳收银台
            let data = res.data.data.order;
            this.$router.push({
              path: '/payType',
              query: data
            });
          }
          //已有订单
          if (res.data.data.result == 3) {
            this.balanceShow = false;
            Dialog.confirm({
              title: '温馨提示',
              message: res.data.data.msg,
              confirmButtonColor: '#2A70F2'
            })
              .then(() => {
                this.$router.push('/myOrder');
              })
              .catch(() => {
                // this.$utils.showToast('用户点击了取消');
              });
            return false;
          }
        });
      } else {
        //非职业培训课程
        //非整体报名
        if (course.isClassApply == '01') {
          this.$router.push({
            path: '/classDetail',
            query: { classId: course.id }
          });
        } else {
          //整体报名
          //判断余额是否抵扣
         if (this.balance !== 0 || this.surplusIntegral != 0) {
            this.classPrice = course.classPrice;
            this.balanceShow = true;
            this.classIds = course.id;
            this.balanZkNum = this.balance - course.classPrice;
            this.balanZkNum1 = (this.surplusIntegral / 30).toFixed(2) - course.classPrice;
          } else {
            this.classIds = course.id;

            this.toOrder();
          }
        }
      }
    },
    //购买生成订单
    toOrder() {
      if (this.payFalg) {
        this.$utils.showToast('点击过快，请稍后再试！');
        return false;
      }
      let data = {
        classId: this.classIds,
                derateType: this.balanRadio[0] == '1' ? '01' : this.balanRadio[0] == '2' ? '02' : '03', //判断是否勾选了抵扣
        courseIds: '',
        equipment: '02'
      };
      this.payFalg = true;
      setTimeout(() => {
        this.payFalg = false;
      }, 5000);
      toGenerateOrder(data).then(res => {
        this.payFalg = false;
        if (res.data.data.result == 0) {
          //创建订单失败返回信息
          this.$utils.showToast(res.data.data.msg);
          this.balanceShow = false;
          return false;
        }
        if (res.data.data.result == 1) {
          //余额小于金额，抵扣后跳转到收银台继续支付或没勾选账户抵扣跳收银台
          let data = res.data.data.order;
          this.$router.push({
            path: '/payType',
            query: data
          });
        }
        //余额大于金额，直接购买成功
        if (res.data.data.result == 2) {
          let data = res.data.data.order;
          this.$router.push({
            path: '/paySuccess',
            query: data
          });
        }
        //已有订单
        if (res.data.data.result == 3) {
          this.balanceShow = false;
          Dialog.confirm({
            title: '温馨提示',
            message: res.data.data.msg,
            confirmButtonColor: '#2A70F2'
          })
            .then(() => {
              this.$router.push('/myOrder');
            })
            .catch(() => {
              // this.$utils.showToast('用户点击了取消');
            });
          return false;
        }
      });
    },
    //去资源库
    gotozyk() {
      this.$router.push('/resource');
    },
    //去资源库播放页
    handleWatch(item) {
      console.log(item);
       ylxAddOrder({ orderId: item.orderId }).then(res => {
          setTimeout(() => {
      this.$router.push({
        path: '/zykPlayer2',
        query: {
          courseId: item.id,
          // classId: item.classId,
          courseWareId: item.cwId,
          courseName: item.cName
        }
      }); }, 1000);

        })
    },
    //去资源库试看
    trySee1(item) {
      this.$router.push({
        path: '/kczyktryPlaying',
        query: { id: item.id }
      });
    },
    //去邀请新用户页面
    handleInvited() {
      this.$router.push({
        path: '/newUser',
        
      });
    },
    noVip(t) {
      //  看是否购买了，购买了跳视频页
      if (t.isBuy == '02') {
         ylxAddOrder({ orderId: t.orderId }).then(res => {
          setTimeout(() => {
        this.$router.push({
          path: '/zykPlayer',
          query: {
            courseId: t.id,
            // classId: item.classId,
            courseWareId: t.cwId,
            courseName: t.cName
          }
        });  }, 1000);

        })
      } else {
        this.$router.push({
          path: '/kczyktryPlaying',
          query: { id: t.id }
        });
      }
    },
    //获取课程资源库
    getkczy() {
      const token = localStorage.getItem('token') || '';
      const params = {
        token: token,
        codeNo: '09',
        courseName: '',
        choose: '1',
        pageNum: 1,
        pageSize: 4
      };
      toCourseList(params).then(res => {
        if (res.data.data.isMember) {
          this.isMember = res.data.data.isMember;
        } else {
          this.isMember = '01';
        }
        this.zylList = res.data.data.ph.rows.slice(0, 4);
        window.scrollTo({
          top: 0
        });
      });
    },
    //跳转
    goYm(type) {
      if (type == 1) {
        this.$router.push('/chooseClass');
      } else if (type == 2) {
        this.$router.push('/myClass');
      } else if (type == 3) {
        this.$router.push('/zscy');
      } else if (type == 4) {
        this.$router.push('/practice');
      }
    },
    // 设置底部导航按钮状态
    setNavBottom() {}
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.getInfo();
    this.setNavBottom();
    this.getkczy();
    this.toAllReadyBuy();
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    setTimeout(() => {
      this.ajaxFalg = false;
    }, 5000);
    this.$nextTick(() => {
      window.scrollTo({
        top: 0
      });
    });
  },

  beforeCreate() {} // 生命周期 - 创建之前
};
</script>
<style lang="less" scoped>
/* //@import url(); 引入公共css类 */
.flowTk {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  overflow: hidden;
  display: flex;
  justify-content: center;
  .tkBox {
    position: relative;
    .close {
      position: absolute;
      top: 80px;
      right: 0px;
      z-index: 99;
      width: 30px;
      cursor: pointer;
    }
    .tkImg {
      width: 330px;
      margin-top: 80px;
      cursor: pointer;
    }
  }
  
}
.tk {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 99999;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 15px;
  .wtkBox {
    width: 100%;
    height: 165px;
    position: relative;
    padding: 26px 29px;
    .tkBac {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 165px;
      z-index: -1;
    }
    .closeBox {
      width: 24px;
      height: 24px;
      position: absolute;
      bottom: -30px;
      left: 50%;
      transform: translate(-50%);
      cursor: pointer;
    }

    .wxTtile {
      font-size: 13px;
      color: #333333;
    }
    .wx2 {
      margin-top: 12px;
      font-size: 14px;
      color: #333;
    }
    .wxBtn {
      margin-top: 13px;
      width: 120px;
      height: 40px;
      background: linear-gradient(97deg, #2a70f2 0%, #669cff 100%);
      box-shadow: 0px 3px 4px 0px rgba(21, 85, 202, 0.31);
      border-radius: 20px 20px 20px 20px;
      text-align: center;
      line-height: 40px;
      font-size: 12px;
      color: #fff;
      cursor: pointer;
    }
  }
}
.head {
  width: 100%;
  height: 42px;
  text-align: center;
  line-height: 42px;
  color: #26292c;
  font-size: 17px;
  background: #fff;
  font-weight: 600;
}
.group_1 {
  margin-top: 10px;
  display: flex;
  padding: 9px 15px;
  align-items: center;
  justify-content: space-between;
  // width: 345px;
  height: 50px;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
  .group_icon {
    // width: 12px;
    // height: 12px;
    img {
      width: 12px;
      height: 12px;
    }
  }
  .text_1 {
    margin-left: 12px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #333333;
    width: 170px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .text_2 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #999999;
  }
  .group_img {
    width: 31px;
    height: 32px;
    img {
      width: 31px;
      height: 32px;
    }
  }
}
.searCh {
  width: 100%;
  height: 60px;
  background: #fff;
  padding-top: 7px;
  display: flex;
  justify-content: center;
  padding: 0 15px;
  .searI {
    width: 100%;
    height: 42px;
    background: #f6f8fa;
    border-radius: 8px 8px 8px 8px;
    border: 0 !important;
    padding-left: 30px;
    color: #999999;
    font-size: 13px;
  }
  .serFle {
    display: flex;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #999999;
    font-size: 13px;
    align-items: center;
  }
  .sera {
    width: 16px;
    height: 16px;
    margin-top: 4px;
  }
}

.banner {
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 0 15px;
  .bns {
    width: 100%;
    .my-swipe {
      width: 100%;
      height: 120px;
      margin-top: 10px;
      .swImg {
        width: 100%;
        height: 120px;
      }
    }

    .xkList {
      width: 100%;
      height: 90px;
      display: flex;
      justify-content: space-between;
      margin-top: 10px;
      background: #fff;
      padding: 14px 20px 15px 20px;
      border-radius: 8px 8px 8px 8px;
      .xkImg {
        width: 40px;
        height: 40px;
      }
      .xkText {
        text-align: center;
        margin-top: 4px;
        font-size: 12px;
      }
    }

    .zjjy {
      margin-top: 10px;
      width: 100%;
      background: #fff;
      padding: 20px 0 20px 15px;
      border-radius: 8px 8px 8px 8px;
      .zjHead {
        display: flex;
        justify-content: space-between;
        padding-right: 15px;
        .zjh1 {
          display: flex;
          align-items: center;
          img {
            width: 11px;
            height: 17px;
            margin-top: 4px;
          }
          .z1txt {
            margin-left: 8px;
            font-size: 17px;
            font-weight: bold;
            color: #333333;
          }
        }
        .zjh2 {
          display: flex;
          align-items: center;
          img {
            width: 12px;
            height: 12px;
            margin-top: 4px;
            margin-left: 2px;
          }
          .zh2 {
            font-weight: 400;
            font-size: 12px;
            color: #999999;
          }
        }
      }

      .scotl {
        margin-top: 16px;
        display: flex;
        overflow-x: auto;
        padding-bottom: 11px;

        .zyBox {
          height: 32px;
          background: #f6f8fa;
          border-radius: 15px 15px 15px 15px;
          text-align: center;
          line-height: 32px;
          color: #666666;
          font-size: 14px;
          margin-right: 10px;
          flex-shrink: 0;
          padding: 0 12px;
        }
        .activeBox {
          background: rgba(42, 112, 242, 0.1) !important;
          color: #2a70f2 !important;
        }
      }
      .bto {
        height: 1px;
        background: #eeeeee;
      }
      .courseBox {
        display: flex;
        margin-top: 16px;
        margin-bottom: 8px;
        .couImg {
          width: 110px;
          height: 88px;
          border-radius: 8px 8px 8px 8px;
        }
        .courseText {
          max-width: 170px;
          margin-left: 10px;
          .c1 {
            width: 170px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            margin-top: 3px;
            font-weight: 500;
            font-size: 16px;
            color: #000000;
          }
          .c2 {
            margin-top: 8px;
            font-weight: 500;
            font-size: 13px;
            color: #666666;
          }
          .c3 {
            // width: 180px;

            display: flex;
            margin-top: 11px;
            font-weight: 500;
            font-size: 13px;
            color: #666666;
          }
          .paly {
            width: 74px;
            height: 32px;
            background: #f3f3f5;
            border-radius: 27px 27px 27px 27px;
            display: flex;
            align-items: center;
            padding-left: 14px;
            img {
              width: 16px;
              height: 16px;
              margin-top: 3px;
            }
            .sk {
              color: #2a70f2;
              font-size: 13px;
            }
          }
        }
      }
    }

    .gkk {
      margin-top: 30px;
      .zjHead {
        display: flex;
        justify-content: space-between;
        padding-right: 15px;
        margin-bottom: 16px;
        .zjh1 {
          display: flex;
          align-items: center;
          img {
            width: 11px;
            height: 17px;
            margin-top: 4px;
          }
          .z1txt {
            margin-left: 8px;
            font-size: 17px;
            font-weight: bold;
            color: #333333;
          }
        }
        .zjh2 {
          display: flex;
          align-items: center;
          img {
            width: 12px;
            height: 12px;
            margin-top: 4px;
            margin-left: 2px;
          }
          .zh2 {
            font-weight: 400;
            font-size: 12px;
            color: #999999;
          }
        }
      }

      .gkkBox {
        width: 100%;
        height: 230px;
        background: #ffffff;
        border-radius: 10px 10px 10px 10px;
        margin-bottom: 10px;
        overflow: hidden;
        img {
          width: 100%;
          height: 160px;
        }
        .gkBtm {
          display: flex;
          justify-content: space-between;
          padding: 10px 15px 8px 15px;
          .g1 {
            font-weight: 500;
            font-size: 15px;
            color: #000000;
          }
          .g2 {
            margin-top: 6px;
            font-size: 12px;
            color: #667280;
          }
          .yyBox {
            width: 74px;
            height: 32px;
            background: #2a70f2;
            border-radius: 27px 27px 27px 27px;
            text-align: center;
            line-height: 32px;
            color: #fff;
            font-size: 13px;
            margin-top: 15px;
          }
        }
      }
    }

    .gygc {
      width: 100%;
      background: #ddeefc;
      border-radius: 8px 8px 8px 8px;
      padding: 20px 15px;
      .gyHead {
        width: 100%;
        display: flex;
        justify-content: center;
        .gyTitle {
          display: flex;
          align-items: center;
          img {
            width: 9px;
            height: 17px;
            margin-top: 4px;
          }
          .gy1 {
            margin: 0 10px;
            color: #333333;
            font-size: 17px;
            font-weight: bold;
          }
        }
      }

      .gybc {
        margin-top: 16px;
        width: 100%;
        height: 55px;
        padding-top: 9px;
        position: relative;
        img {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
        }
        .bc1 {
          font-weight: Bold;
          color: #fff;
          font-size: 16px;
          text-align: center;
        }
        .bc2 {
          color: #fff;
          font-size: 12px;
          text-align: center;
        }
      }

      .gcTxt {
        margin-top: 16px;
        display: flex;
        justify-content: space-between;
        .gct1 {
          padding: 10px;
          background: #ffffff;
          border-radius: 10px 10px 10px 10px;
          width: 32%;
          font-size: 14px;
          color: #656e7e;
        }
        .gct2 {
          padding: 10px;
          background: #ffffff;
          border-radius: 10px 10px 10px 10px;
          width: 49%;
          font-size: 14px;
          color: #656e7e;
        }
      }
    }
  }
}
.rapid {
  width: 100%;
  height: 230px;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
  margin-top: 10px;
  padding: 20px 15px;
  .rapid_box {
    margin-top: 17px;
    display: flex;
    justify-content: space-between;
    .title_3 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 600;
      font-size: 13px;
      color: #333333;
    }
    .title_4 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 11px;
      color: #545454;
      margin-top: 4px;
    }
    .box_left {
      width: 32%;
      height: 151px;
      background-image: url('../assets/new/Group 1361@2x.png');
      background-size: 100%;
      background-repeat: no-repeat;
      padding: 16px 9px;
      border-radius: 8px 8px 8px 8px;
    }
    // .box_right {
    //   margin-left: 8px;
    //   width: 60%;
    //   display: flex;
    .box_1 {
      width: 32%;
      height: 151px;
      background-image: url('../assets/new/Group 1362@2x.png');
      background-size: 100%;
      background-repeat: no-repeat;
      border-radius: 8px 8px 8px 8px;
      margin-bottom: 9px;
      padding: 16px 9px;
    }
    .box_2 {
      width: 32%;
      height: 151px;
      background-image: url('../assets/new/Group 1363@2x.png');
      background-size: 100%;
      background-repeat: no-repeat;
      padding: 16px 9px;
      border-radius: 8px 8px 8px 8px;
    }
    // }
  }
  .rapid_ti {
    display: flex;
    align-items: center;
    .rapid_img {
      img {
        width: 11px;
        height: 17px;
      }
      width: 11px;
      height: 17px;
    }
    .title_1 {
      font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
      font-weight: bold;
      font-size: 16px;
      color: #333333;
      margin-left: 8px;
    }
    .title_2 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 12px;
      color: #999999;
      margin-left: 12px;
    }
  }
}
.bofang {
  display: inline-block;
  width: 50px;
  height: 32px;
  background: #f3f3f5;
  border-radius: 27px 0px 0px 27px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #2a70f2;
  text-align: center;
  line-height: 32px;

  img {
    width: 16px;
    height: 16px;
  }
}
.pay {
  width: 50px;
  display: inline-block;

  height: 32px;
  background: linear-gradient(97deg, #2a70f2 0%, #669cff 100%);
  border-radius: 0px 27px 27px 0px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 13px;
  color: #ffffff;
  text-align: center;
  line-height: 32px;
}
.balanBox {
  width: 300px;
  height: auto;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
  padding: 22px 20px;
  .b1 {
    color: #333333;
    font-size: 15px;
    font-weight: 500;
    text-align: center;
  }
  .bn2 {
    margin-top: 20px;
    width: 100% !important;
    background: #f6f8fa !important;
    border-radius: 8px 8px 8px 8px;
    .b2 {
      color: #333333;
      font-size: 14px;
    }
    .b3 {
      color: #999999;
      font-size: 12px;
    }
  }

  .btnBox {
    display: flex;
    justify-content: space-between;
    .btn {
      margin-top: 20px;
      width: 117px;
      height: 48px;
      background: linear-gradient(90deg, #ff8285 0%, #e74f52 100%);
      border-radius: 8px 8px 8px 8px;
      text-align: center;
      line-height: 48px;
      font-size: 15px;
      color: #fff;
    }
  }
}
.kczyk {
  margin-top: 30px;
  .kcHead {
    display: flex;
    justify-content: space-between;
    padding-right: 15px;
    img {
      width: 11px;
      height: 17px;
    }
  }
  .z1txt {
    margin-left: 8px;
    font-size: 17px;
    font-weight: bold;
    color: #333333;
  }
  .zjh1 {
    display: flex;
    align-items: center;
  }
  .zjh2 {
    display: flex;
    align-items: center;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #999999;
    img {
      width: 12px;
      height: 12px;
    }
  }
  .zykBox {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .zykBox_1 {
      margin-top: 17px;
      width: 48%;
      height: 235px;
      background: #ffffff;
      border-radius: 8px 8px 8px 8px;
      .zykimg {
        width: 100%;
        height: 134px;
        border-radius: 8px 8px 0px 0px;
        img {
          width: 100%;
          height: 134px;
          border-radius: 8px 8px 0px 0px;
        }
      }
      .zyktext {
        padding: 12px 16px 9px 12px;
        .zyktext_1 {
          font-family: PingFang SC, PingFang SC;
          font-weight: 500;
          font-size: 14px;
          color: #000000;
          min-height: 40px;
          width: 140px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .zyktext_2 {
          margin-top: 8px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .zyk1 {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 13px;
            color: #656e7e;
          }
          .zyk2 {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 74px;
            height: 32px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 13px;
            color: #2a70f2;
            background: #f3f3f5;
            border-radius: 27px 27px 27px 27px;
            img {
              width: 16px;
              height: 16px;
              margin-right: 4px;
            }
          }
        }
      }
    }
  }
}
.newuser {
  height: 58px;
  margin-top: 8px;
  background-image: url('../assets/images/Group 1393@2x (1).png');
  background-size: cover;
  text-align: center;
  font-family: Alibaba PuHuiTi, Alibaba PuHuiTi;
font-weight: 800;
font-size: 16px;
color: #FFFFFF;
line-height: 58px;
}
</style>
